import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { throwError } from "rxjs";
import { map, catchError } from "rxjs/operators";

import { Filter } from '../../models/filter.model';
import { Lookup } from '../../models/admin-models/lookup.model';

@Injectable({
    providedIn: 'root'
})
export class PolicyStatusService {

    constructor(private httpClient: HttpClient) { }

    getOne(id: Number) {
        return this.httpClient.get('api/policystatuses/' + id).toPromise();
    }

    gridView() {
        return this.httpClient.get('api/policystatuses')
            .pipe(
                map((res: any) => {
                    return res;
                }),
                catchError((error) => {
                    return throwError(error);
                })
            )
    }

    createPolicyStatus(lookup: Lookup) {
        return this.httpClient.post('api/policystatuses/create', lookup.data).toPromise();
    }

    editPolicyStatus(lookup: Lookup) {
        return this.httpClient.post('api/policystatuses/edit', lookup.data).toPromise();
    }

    deletePolicyStatus(ids: Array<Number>) {
        return this.httpClient.post('api/policystatuses/delete', ids).toPromise();
    }

}